module.exports = __webpack_public_path__ + "static/media/SPLogo.e6feb900.svg";